export default __webpack_public_path__ + "static/media/nft2.d2d960f1.jpg";